import { FC, useState } from 'react';
import { CounterTypeProps } from './TypeProps';
import { IconPlus, IconMinus } from './icons';
import { PopupCondition } from '../PopupRemainder/PopupСondition';
import { PopupConditionV2 } from '../PopupRemainder/PopupConditionV2';
import classNames from 'classnames';

import styles from './Counter.module.scss';

export const Counter: FC<CounterTypeProps> = ({
  className,
  count,
  handleIncrement,
  handleDecrement,
  handleChange,
  max,
  min,
  editable,
  part,
  allQuantity,
  sign,
}) => {
  const [countLimit, setCountLimit] = useState<boolean>(false);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);

  const incrementCounter = () => {
    if (count < max || count < allQuantity) {
      handleIncrement();
      setCountLimit(false);
      setIsPopupOpen(false);
      return;
    }
    setCountLimit(true);
    setIsPopupOpen(true);
  };

  const decrementCounter = () => {
    setCountLimit(false);
    setIsPopupOpen(false);
  };

  return (
    <div className={classNames(styles.Container, className)} data-testid="btn-counter">
      {isPopupOpen &&
        (sign ? (
          <PopupCondition part={part} countLimit={countLimit} max={max} allQuantity={allQuantity} onClose={() => setIsPopupOpen(false)} />
        ) : (
          <PopupConditionV2 part={part} countLimit={countLimit} max={max} allQuantity={allQuantity} onClose={() => setIsPopupOpen(false)} />
        ))}
      <IconMinus
        data-testid="btn-counter-minus"
        className={classNames(styles.Minus, min && count === min && styles.Disable)}
        onClick={() => {
          handleDecrement();
          decrementCounter();
        }}
      />
      {editable ? (
        <input className={styles.ValueInput} type="text" value={count} onChange={event => handleChange(parseInt(event.target.value) || 0)} />
      ) : (
        <div className={styles.Value}>{count}</div>
      )}
      <IconPlus
        data-testid="btn-counter-plus"
        className={classNames(styles.Plus, max && count === max && styles.Disable)}
        onClick={incrementCounter}
      />
    </div>
  );
};
